import { IconBox } from "src/pages/register/Register.style";
import { ReactComponent as IconChecked } from "../../../styles/assets/svg/icon_checked.svg";

interface toggleBtnProp {
  isActive: boolean;
  setIsActive: (e: any) => void;
}

export const ToggleBtn = ({ isActive, setIsActive }: toggleBtnProp) => {
  return (
    <div
      style={{
        width: "40px",
        height: "24px",
        padding: isActive ? "2px 2px 2px 18px" : "2px 18px 2px 2px",
        background: isActive ? "#F57C00" : "#9CA3AF",
        borderRadius: 50,
        display: "flex",
        alignItems: "center",
        position: "relative",
        transition: "padding 0.3s ease, background 0.3s ease",
        cursor: "pointer",
      }}
      onClick={() => setIsActive(!isActive)}
    >
      <div
        style={{
          width: "100%",
          height: "100%",
          padding: "4px 3px",
          background: "var(--white, white)",
          borderRadius: 99,
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          gap: 10,
          display: "flex",
        }}
      >
        <IconBox $isActive={isActive}>
          <IconChecked />
        </IconBox>
      </div>
    </div>
  );
};
